var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfrastructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.26 58.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.58,15.31c-1.27,.13-1.78,.39-3.15,1.09l-2.52,1.3c-.38,.19-.7,.51-.89,.87-.04,.08-.07,.18-.11,.27-.04,.11-.09,.22-.13,.31-.23,.62-.5,1.2-1.53,1.77-.7,.36-1.52,.29-2.11-.18l-2.88,1.48,2.31,4.5,2.74-1.44c-.04-.77,.37-1.49,1.06-1.85,1.14-.59,1.77-.46,2.54-.21,.16,.05,.3,.09,.51,.14,.39,.05,.8-.02,1.17-.21l2.5-1.21c-.4-2.06,.53-4.04,2.37-4.99,.93-.48,1.76-.8,2.54-.98-1.48-.63-2.9-.84-4.41-.66",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7,43.91l-4.88,2.51c-.21,.11-.43,.16-.64,.16-.5,0-.97-.28-1.22-.76l-10.15-19.76c-.25-.04-.45-.1-.62-.16-.06,.64-.46,1.24-1.05,1.55l-3.56,1.87c-.61,.31-1.29,.37-1.93,.16-.63-.21-1.14-.65-1.45-1.24l-2.56-4.98c-.31-.61-.37-1.29-.16-1.93,.21-.63,.65-1.14,1.24-1.45l3.68-1.89c.6-.31,1.25-.31,1.8,0,.08-.2,.18-.42,.31-.68,.46-.9,1.2-1.64,2.08-2.1l2.52-1.29c1.48-.76,2.37-1.22,4.14-1.39,3.77-.47,7.03,.85,11.23,4.55h0c.49,.44,.59,1.17,.24,1.71-.16,.25-.33,.42-.55,.53-.33,.17-.68,.19-1.05,.08l-.84-.27c-2.21-.71-3.12-1-5.58,.26-.61,.31-.83,.81-.91,1.16-.1,.46-.03,.98,.19,1.42l.05,.1,10.26,19.97c.35,.69,.09,1.51-.6,1.87M29.13,0C13.04,0,0,13.04,0,29.13s13.04,29.13,29.13,29.13c16.08-.02,29.11-13.05,29.13-29.13C58.26,13.04,45.22,0,29.13,0",
    style: {
      fill: "#c42032"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/Infrastructure.023fb5eb12d5e0bc7f46d7f52805a8e3.svg";
export { ForwardRef as ReactComponent };